import { MutationLifecycleApi, QueryLifecycleApi } from '../../types/rtkInternals'

type LifecycleApi = MutationLifecycleApi<any, any, any> | QueryLifecycleApi<any, any, any>

export type RequestSideEffect<Params, Result> = (
  params: Params,
  result: Result,
  api: LifecycleApi
) => void

type Config<Params, Result> = {
  success?: Array<RequestSideEffect<Params, Result>>
  failure?: Array<RequestSideEffect<Params, Result>>
}

// Just a syntax sugar to make easier effects based on rtkq endpoint result - see usage
export const bindSideEffects =
  <Params, Result extends { data: any }>(definitions: Config<Params, Result['data']>) =>
  async <Api extends LifecycleApi>(params: Params, api: Api) => {
    api.queryFulfilled
      .then(result => definitions.success?.forEach(effect => effect(params, result, api)))
      .catch(result => definitions.failure?.forEach(effect => effect(params, result, api)))
  }
